import { useState, useEffect } from "react";

import { Container, Row, Col } from "react-bootstrap";
import { ArrowRightCircle } from "react-bootstrap-icons";
import TrackVisibility from "react-on-screen";

import headerImg from "../assets/img/header-img.svg";

import "animate.css";

export const Banner = () => {
  const [loopNum, setLoopNum] = useState(0);
  const [isDeleting, setIsDeleting] = useState(false);
  const [text, setText] = useState("");
  const [delta, setDelta] = useState(250 - Math.random() * 100);
  const [deleteSpeed, setDeleteSpeed] = useState(240);
  const period = 2500;

  useEffect(() => {
    const toRotate = ["Programmer", "Frontend Developer", "Software Engineer"];

    const tick = () => {
      let i = loopNum % toRotate.length;
      let fullText = toRotate[i];
      let updatedText = isDeleting
        ? fullText.substring(0, text.length - 1)
        : fullText.substring(0, text.length + 1);

      setText(updatedText);

      if (isDeleting) {
        if (deleteSpeed > 30) {
          setDeleteSpeed(deleteSpeed - 30);
        }
        setDelta(deleteSpeed);
      }

      if (!isDeleting && updatedText === fullText) {
        setIsDeleting(true);
        setDelta(period);
        setDeleteSpeed(240);
      } else if (isDeleting && updatedText === "") {
        setIsDeleting(false);
        setLoopNum(loopNum + 1);
        setDelta(250 - Math.random() * 100);
      }
    };

    const ticker = setInterval(() => {
      tick();
    }, delta);

    return () => {
      clearInterval(ticker);
    };
  }, [delta, loopNum, text, isDeleting, deleteSpeed]);

  return (
    <section className="banner" id="home">
      <Container>
        <Row className="align-items-center">
          <Col xs={12} md={6} xl={7}>
            <TrackVisibility>
              {({ isVisible }) => (
                <div
                  className={
                    isVisible ? "animate__animated animate__fadeIn" : ""
                  }
                >
                  <span className="tagline">Welcome to my Portfolio</span>
                  <h1>
                    {`Hello! I'm Chad, a `}
                    <br />
                    <span
                      className="txt-rotate"
                      data-period="1000"
                      data-rotate='[ "Programmer", "Frontend Developer", "Software Engineer" ]'
                    >
                      <span className="wrap">{text}</span>
                    </span>
                  </h1>
                  <p>
                    I’m a Software Engineer with working experience and a strong
                    foundation in Python, C++, and Java. I’ve built custom
                    Discord bots, plugins, websites, and mobile applications.
                    I’m passionate about creating tools that turn complex
                    problems into simple experiences for users.
                  </p>
                  <button
                    onClick={() =>
                      document
                        .getElementById("connect")
                        .scrollIntoView({ behavior: "smooth" })
                    }
                  >
                    Let’s Connect <ArrowRightCircle size={25} />
                  </button>
                </div>
              )}
            </TrackVisibility>
          </Col>
          <Col xs={12} md={6} xl={5}>
            <TrackVisibility>
              {({ isVisible }) => (
                <div
                  className={
                    isVisible ? "animate__animated animate__zoomIn" : ""
                  }
                >
                  <img src={headerImg} alt="Header Img" />
                </div>
              )}
            </TrackVisibility>
          </Col>
        </Row>
      </Container>
    </section>
  );
};
